export default "__VITE_ASSET__OtSEB8WX__"